import { useCallback, useEffect, useMemo } from 'react';
import { useIMask } from 'react-imask';
import {
  FormControl,
  FormHelperText,
  FormLabel,
  OutlinedInput,
  type OutlinedInputProps,
} from '@mui/material';
import { withControl } from '../../hoc/withControl';

export const VehicleLicencePlateControl = withControl<OutlinedInputProps>(
  ({
    label,
    value,
    setValue,
    error,
    isError,
    required,
    readOnly,
    disabled,
    placeholder = 'A000AA 000',
  }) => {
    const handleAccept = useCallback(
      (newValue: string, _mask: unknown, event?: InputEvent) => {
        if (!event) {
          return;
        }

        setValue(newValue);
      },
      [setValue]
    );

    const maskOptions = useMemo(
      () => ({
        mask: 'a000aa 00[0]',
        definitions: { a: /[ABEKMHOPCTYXАВЕКМНОРСТУХ]/ },
        prepare: (entered: string) => entered.toUpperCase(),
      }),
      []
    );

    const { ref, maskRef } = useIMask(maskOptions, {
      onAccept: handleAccept,
    });

    useEffect(() => {
      const nextValue = value || '';

      if (maskRef.current && nextValue !== maskRef.current.value) {
        maskRef.current.value = nextValue;
      }
    }, [value, maskRef]);

    return (
      <FormControl disabled={disabled}>
        {label && (
          <FormLabel required={!readOnly && required} error={isError}>
            {label}
          </FormLabel>
        )}
        <OutlinedInput
          inputRef={ref}
          defaultValue={value}
          readOnly={readOnly}
          disabled={disabled}
          error={isError}
          placeholder={placeholder}
        />
        {error && <FormHelperText error>{error}</FormHelperText>}
      </FormControl>
    );
  }
);
